import * as React from 'react';

import { Checkbox, Dialog, FontIcon, RaisedButton } from 'material-ui';
import { GlanceData, GlanceMeta, GlanceMetaState, GlancePair, Partner, Region, StudioAppConfig } from 'glance-datatypes';
import { black, cyan100, green300, green500, grey300, orange500, red300, red500 } from 'material-ui/styles/colors';

import GlanceCard from './GlanceCard';
import Utils from '../Utils';
import { connect } from 'react-redux';

const articleIcon = <FontIcon className='material-icons'>web</FontIcon>;
const videoIcon = <FontIcon className='material-icons'>play_circle_outline</FontIcon>;

const styles = {
    button: {
        marginTop: '0px',
    } as React.CSSProperties,
    stateLabel: {
        borderRadius: '50px',
        display:'inline-block',
        padding: '5px',
        color: '#fff',
        position: 'absolute',
        right: 0,
        zIndex: 3,
        fontSize: '10px',
    } as React.CSSProperties,
    deleteButton : {
        color: red500,
        background: red300,
    } as React.CSSProperties,
    removedGlanceBackground : {
        backgroundColor: '#E8E8E8',
    } as React.CSSProperties,
    selectButton : {
        color: black,
        background: grey300,
    } as React.CSSProperties,
    selectedButton : {
        color: green500,
        background: green300,
    } as React.CSSProperties,
    selectedGlanceCard : {
        backgroundColor: cyan100,
    } as React.CSSProperties,
    articleButton : {

    } as React.CSSProperties,
    nativeButton : {
        backgroundColor: '#3b5998',
        color: '#8b9dc3',
    }as React.CSSProperties,
    facebookButton : {
        backgroundColor: '#3b5998',
        color: '#8b9dc3',
    } as React.CSSProperties,
    youtubeButton : {
        backgroundColor: '#cc181e',
        color: '#f1f1f1',
    } as React.CSSProperties,
    instaButton : {
        backgroundColor: '#125688',
        color: '#f1f1f1',
    } as React.CSSProperties,
    youkuButton : {
        backgroundColor: '#EE4023',
        color: '#06A6E0',
    } as React.CSSProperties,
};

interface Props {
    glance: GlancePair;
    partner: Partner;
    region: Region;
    selected: boolean;
    onSelect: (selected: boolean) => any;
    studioAppConfig?: StudioAppConfig;
}

interface State {
    openDetailsDialog: boolean;
}

class Glance extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            openDetailsDialog: false,
        };

        this.openDetailsDialog = this.openDetailsDialog.bind(this);
        this.closeDetailsDialog = this.closeDetailsDialog.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    onSelect() {
        const selected = !this.props.selected;
        this.props.onSelect(selected);
    }

    openDetailsDialog() {
         this.setState({
            ...this.state,
            openDetailsDialog: true,
        });
    }

    closeDetailsDialog() {
        this.setState({
            ...this.state,
            openDetailsDialog: false,
        });
    }

    render() {
        let isMetaArray: boolean = false;
        if ( 'partnerIds' in this.props.glance.meta) {
            isMetaArray = true;
        }
        const data : GlanceData = this.props.glance.data;
        const meta : GlanceMeta = this.props.glance.meta;
        const partner = this.props.partner ? this.props.partner.name : '';
        const selected = this.props.selected;

        const selectButton = (isMetaArray
        ? (meta.state == GlanceMetaState.INTERNAL_PENDING)
        : (meta.state == GlanceMetaState.STUDIO_APPROVED
        || meta.state == GlanceMetaState.INMOBI_APPROVED
        || meta.state == GlanceMetaState.INTERNAL_APPROVED
        || meta.state == GlanceMetaState.PARTNER_APPROVED || !meta.state)) ?  (
            <Checkbox
      label=''
      style={{position:'absolute'}}
      key='select_button'
      checked={this.props.selected}
      onCheck={this.onSelect}

    />
        ) : null;

        const moreDetailsButton = (
            <RaisedButton
                key='more_details'
                onClick={this.openDetailsDialog}
                label='Details'
                primary={true}
                style={styles.button}
                icon={<FontIcon className='material-icons'>info</FontIcon>}
                fullWidth={!this.state.openDetailsDialog}
            />
        );

        const closeDetailsButton = (
            <RaisedButton
                key='close_details'
                onClick={this.closeDetailsDialog}
                label='Close'
                primary={true}
                style={styles.button}
                fullWidth={!this.state.openDetailsDialog}
                icon={<FontIcon className='material-icons'>close</FontIcon>}
            />
        );

        const glanceActions = [];
        const glanceDialogActions = [];

        let peekButton;
        const getUpdatedUrl = (url: string) => {
        if (partner === 'Transsion') {
            const convertedUrl = Utils.convertTo3pLite(url);
            return Utils.updateUrlParams(convertedUrl, {utm_medium: 'trans'});
        }
          return url;
        }
        if (data.peek) {
            if (data.peek.article) {
                peekButton = (
                    <RaisedButton
                        key='peek_article'
                        onClick={() => {Utils.openNewTab(getUpdatedUrl(data.peek.article.cta.url));}}
                        label='Read'
                        secondary={true}
                        style={{...styles.button}}
                        buttonStyle={styles.articleButton}
                        icon={articleIcon}
                        fullWidth={!this.state.openDetailsDialog}
                    />
                );
            } else if (data.peek.nativeVideoPeek && data.peek.nativeVideoPeek.videoUrl) {
                peekButton = (
                    <RaisedButton
                        key='peek_facebook'
                        onClick={() => {Utils.openNewTab('/#/peek/native?url=' + encodeURIComponent(data.peek.nativeVideoPeek.videoUrl));}}
                        label='Video'
                        primary={true}
                        style={{...styles.button}}
                        buttonStyle={styles.nativeButton}
                        icon={videoIcon}
                        fullWidth={!this.state.openDetailsDialog}
                    />
                );
            }else if (data.peek.video) {
                const videoMeta = data.peek.video.video.meta;
                if (videoMeta.facebook) {
                    peekButton = (
                        <RaisedButton
                            key='peek_facebook'
                            onClick={() => {Utils.openNewTab('/#/peek/facebook/' + videoMeta.facebook.id);}}
                            label='Facebook'
                            primary={true}
                            style={{...styles.button}}
                            buttonStyle={styles.facebookButton}
                            icon={videoIcon}
                            fullWidth={!this.state.openDetailsDialog}
                        />
                    );
                } else if (videoMeta.youtube) {
                    peekButton = (
                        <RaisedButton
                            key='peek_youtube'
                            onClick={() => {Utils.openNewTab('/#/peek/youtube/' + videoMeta.youtube.id);}}
                            label='Youtube'
                            primary={true}
                            style={{...styles.button}}
                            buttonStyle={styles.youtubeButton}
                            icon={videoIcon}
                            fullWidth={!this.state.openDetailsDialog}
                        />
                    );
                } else if (videoMeta.instagram) {
                     peekButton = (
                        <RaisedButton
                            key='peek_insta'
                            onClick={() => {Utils.openNewTab('/#/peek/instagram/' + videoMeta.instagram.id);}}
                            label='Instagram'
                            primary={true}
                            style={{...styles.button}}
                            buttonStyle={styles.instaButton}
                            icon={videoIcon}
                            fullWidth={!this.state.openDetailsDialog}
                        />
                    );
                } else if (videoMeta.youku) {
                     peekButton = (
                        <RaisedButton
                            key='peek_insta'
                            onClick={() => {Utils.openNewTab('/#/peek/youku/' + videoMeta.youku.id);}}
                            label='Youku'
                            primary={true}
                            style={{...styles.button}}
                            buttonStyle={styles.youkuButton}
                            icon={videoIcon}
                            fullWidth={!this.state.openDetailsDialog}
                        />
                    );
                }
            }
        }

        let stateButtonLabel;
        if (isMetaArray) {
            switch (meta.state) {
                case GlanceMetaState.INTERNAL_PENDING:
                    stateButtonLabel = 'Approval Pending';
                    styles.stateLabel.background = orange500;
                    break;
                case GlanceMetaState.INTERNAL_APPROVED:
                case GlanceMetaState.PARTNER_APPROVED:
                    stateButtonLabel = 'Approved';
                    styles.stateLabel.background = green500;
                    break;
                case GlanceMetaState.INTERNAL_REJECTED:
                    stateButtonLabel = 'Rejected';
                    styles.stateLabel.background = red500;
                    break;
                default:
                    stateButtonLabel = 'Approved';
                    styles.stateLabel.background = green500;
                    break;
            }
        } else {
            switch (meta.state) {
                case GlanceMetaState.STUDIO_APPROVED:
                case GlanceMetaState.INMOBI_APPROVED:
                case GlanceMetaState.INTERNAL_APPROVED:
                    stateButtonLabel = 'Approval Pending';
                    styles.stateLabel.background = orange500;
                    break;
                case GlanceMetaState.PARTNER_APPROVED:
                    stateButtonLabel = 'Approved';
                    styles.stateLabel.background = green500;
                    break;
                case GlanceMetaState.PARTNER_REJECTED:
                    stateButtonLabel = 'Rejected';
                    styles.stateLabel.background = red500;
                    break;
                case GlanceMetaState.PARTNER_REMOVED:
                    stateButtonLabel = 'Removed by partner';
                    styles.stateLabel.background = red500;
                    break;
                case GlanceMetaState.STUDIO_REMOVED:
                case GlanceMetaState.INMOBI_REMOVED:
                    stateButtonLabel = 'Removed by InMobi Studio';
                    styles.stateLabel.background = red500;
                    break;
                default:
                    stateButtonLabel = 'Approved';
                    styles.stateLabel.background = green500;
                    break;
            }
        }

        const stateButton = (<div key='state_button' style={styles.stateLabel}>{stateButtonLabel}</div>);
        if (peekButton) {
            glanceActions.push(peekButton);
            glanceDialogActions.push(peekButton);
        }

        glanceActions.push(moreDetailsButton);
        if (selectButton) {
            glanceActions.push(selectButton);
        }
        glanceActions.push(stateButton);
        glanceDialogActions.push(closeDetailsButton);

        const applicableActions = [stateButton];
        if (selectButton !== null) {
            applicableActions.push(selectButton);
        }

        return (
            <div style={{height: '100%'}}>
                <GlanceCard
                    data={this.props.glance}
                    customStyle={selected ? styles.selectedGlanceCard : (meta.removed ? styles.removedGlanceBackground : {})}
                    actions={glanceActions}
                    region={this.props.region}
                    partner={this.props.partner}
                    studioAppConfig={this.props.studioAppConfig}
                />

                <Dialog modal={false}
                    open={this.state.openDetailsDialog}
                    onRequestClose={this.closeDetailsDialog}
                    contentStyle={{width:'80%', maxWidth: '1400px', margin:'0px auto'}}
                    autoScrollBodyContent={false}
                    actions={glanceDialogActions}
                >
                    <GlanceCard
                        data={this.props.glance}
                        actions={applicableActions}
                        customStyle={{margin:'0px auto'}}
                        detailedView={true} region={this.props.region}
                        partner={this.props.partner}
                        studioAppConfig={this.props.studioAppConfig}
                    />
                </Dialog>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};
export default connect(mapStateToProps)(Glance);




// WEBPACK FOOTER //
// ./src/components/Glance.tsx